import React, { useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  Checkbox,
  Button,
  Grid,
  TextField,
  InputAdornment,
  Box,
  InputLabel,
  Radio,
  Pagination,
  TableFooter,
  Avatar,
  ListItemText,
  Menu,
  Divider,
  Input,
} from "@mui/material";
import {
  Edit,
  Delete,
  Search,
  ExpandLess,
  ExpandMore,
  ArrowUpward,
  ArticleRounded,
  PersonRounded,
  ArrowDropDown,
} from "@mui/icons-material";
import SwapVertIcon from "@mui/icons-material/SwapVert";

import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useNavigate } from "react-router-dom";

import {
  fetchUsers,
  limitStart,
  resetAll,
  resetSearchTerm,
  setRoleStart,
  setRowId,
  setRowsPerPage,
  setSelectedOption,
  setSelectOptionId,
  setSearchTerm,
  setAdminUserData,
} from "../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import DeleteAdminUserPopUp from "./deleteAdminUserPopup";
import ImportUsersModal from "./importUser";

const ManageUsers = () => {
  const navigate = useNavigate();
  let {
    users,
    count,
    isInput,
    roles,
    limit,
    rowsPerPage,
    rowId,
    selectedOption,
    selectOptionId,
    searchTerm,
  } = useSelector((state) => state.userManagement);

  const radioRoleMapping = {
    "Super Admin": "AUR001",
    "Business Admin": "AUR002",
    "Business Users": "AUR003",
    "IT Admin": "AUR004",
    "Support Admin": "AUR005",
    "Support User": "AUR006",
  };

  const [selectedRole, setSelectedRole] = useState({});
  const [deletePopUpOpen, setDeletePopUpOpen] = useState(false);
  const [adminUserIdForDeletion, setAdminUserIdForDeletion] = useState("");

  const [importUsersModalOpen, setImportUsersModalOpen] = useState(false);

  const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState("10");
  // const [rowId, setRowId] = useState("PO002");
  const [open, setOpen] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  // const [selectedOption, setSelectedOption] = useState("");
  // const [selectOptionId, setSelectOptionId] = useState("ALL");
  const [selectRows, setSelectRows] = useState({});
  const textFieldRef = useRef(null);
  // const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  const formattedDate = (date) => {
    if (!date) return "";
    return moment(date).format("MMM DD, YYYY");
  };

  const isInactive = (lastActiveDate) => {
    if (lastActiveDate === null || lastActiveDate === undefined) {
      return "";
    } else {
      const currentDate = new Date();
      const lastActive = new Date(lastActiveDate);
      const diffDate = Math.abs(currentDate - lastActive);
      const diffDays = Math.ceil(diffDate / (1000 * 60 * 60 * 24));
      return diffDays > 30;
    }
  };

  React.useEffect(() => {
    fetchUserManagement(page, rowId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId, rowsPerPage, page]);

  React.useEffect(() => {
    dispatch(setRoleStart());
    const initialRoles = {};
    users.forEach((usr, index) => {
      initialRoles[index] = usr.role_en;
    });
    setSelectedRole(initialRoles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  let paginatedData =
    rowsPerPage === "ALL" || rowsPerPage >= users.length
      ? users
      : users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const fetchUserManagement = (index = 0, rowId) => {
    let offset = rowsPerPage === "ALL" ? 0 : rowsPerPage * index;
    let limit = rowsPerPage === "ALL" ? "ALL" : rowId;
    const params = {
      filter: selectOptionId || "ALL",
      limit: limit,
      offset: offset,
      searchTerm: searchTerm,
    };

    dispatch(fetchUsers({ params, isInput }));
  };

  const fetchUserManagementData = (index = 0, rowId) => {
    let offset = rowsPerPage === "ALL" ? 0 : rowsPerPage * index;
    let limit = rowsPerPage === "ALL" ? "ALL" : rowId;
    const params = {
      filter: selectOptionId || "ALL",
      limit: limit,
      offset: offset,
      searchTerm: searchTerm,
    };

    return { params, isInput };

    // dispatch(fetchUsers({ params, isInput }));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (e, roleName) => {
    if (selectOptionId === e && e.length > 1) {
      return;
    }
    dispatch(setSelectOptionId(e));
    dispatch(setSelectedOption(roleName));
    handleClose(); // Close the menu after selection
    // if(e === 'all_users') {
    const params = {
      filter: e === "ALL" ? "ALL" : e,
      limit: rowsPerPage === "ALL" ? "ALL" : rowId,
      offset: 10,
      searchTerm: searchTerm,
    };
    dispatch(fetchUsers({ params, isInput: false }));
    // }
  };

  React.useEffect(() => {
    if (selectOptionId) {
      const params = {
        filter: selectOptionId,
        limit: "ALL",
        offset: 10,
        searchTerm: searchTerm,
      };
      dispatch(fetchUsers({ params, isInput: false }));
    }
    if (searchTerm === "") {
      dispatch(resetAll());
      dispatch(resetSearchTerm());
      fetchUserManagement(0, rowId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOptionId, searchTerm]);

  const handleTableCheckBox = (e, index) => {
    setSelectRows((prevSelected) => {
      const selectedRowsForPage = prevSelected[page] || [];
      return {
        ...prevSelected,
        [page]: selectedRowsForPage.includes(index)
          ? selectedRowsForPage.filter((rowId) => rowId !== index)
          : [...selectedRowsForPage, index],
      };
    });
  };

  const handleSelectAllCheckBox = (event) => {
    if (event.target.checked) {
      setSelectRows((prevSelected) => {
        const selectedRowsForPage = prevSelected[page] || [];
        return {
          ...prevSelected,
          [page]: [
            ...selectedRowsForPage,
            ...paginatedData
              .map((_, index) => index)
              .filter((index) => !selectedRowsForPage.includes(index)),
          ],
        };
      });
    } else {
      setSelectRows((prevSelected) => {
        const selectedRowsForPage = prevSelected[page] || [];
        return {
          ...prevSelected,
          [page]: selectedRowsForPage.filter(
            (rowId) => !paginatedData.some((_, index) => rowId === index)
          ),
        };
      });
    }
  };

  const isAllSelected =
    paginatedData.length > 0 &&
    paginatedData.every((_, index) => (selectRows[page] || []).includes(index));
  const isIndeterminate =
    paginatedData.some((_, index) =>
      (selectRows[page] || []).includes(index)
    ) && !isAllSelected;

  const handleRole = (index, value, admin_user_id, admin_user_role_id) => {
    setSelectedRole((prevState) => ({
      ...prevState,
      [index]: value,
    }));
    dispatch(
      setAdminUserData({
        data: { admin_user_role_id: radioRoleMapping[value] },
        admin_user_id: admin_user_id,
        type: "R",
      })
    );
  };

  const handleToggle = (index, isOpen) => {
    setOpen((prevState) => ({
      ...prevState,
      [index]: isOpen,
    }));
  };

  const handleAddUser = (value) => {
    navigate(`/manage-user`);
  };

  const handleChangeRowsPerPage = (event, id) => {
    const value = event;
    const newValue = value === "ALL" ? "ALL" : value;

    dispatch(setRowsPerPage(newValue));
    dispatch(setRowId(id));
    setPage(0);
    fetchUserManagement(0, id);
  };

  React.useEffect(() => {
    dispatch(limitStart());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
    fetchUserManagement(newPage - 1, rowId);
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    dispatch(setSearchTerm(value));
    setPage(0);
    if (value === "") {
      handleClearInput();
    }
  };

  const handleFilterSubmit = (event) => {
    event.preventDefault();
    if (searchTerm) {
      dispatch(resetAll());
      setPage(0);
      dispatch(
        fetchUsers({
          params: {
            filter: selectOptionId || "ALL",
            limit: "ALL",
            offset: 0,
            searchTerm: searchTerm,
          },
          isInput: true,
        })
      );
    }
  };

  const handleKeyDown = (e) => {
    if (e.which === 13 && e.shiftKey === false && searchTerm) {
      dispatch(resetAll());
      setPage(0);
      dispatch(
        fetchUsers({
          params: {
            filter: selectOptionId || "ALL",
            limit: "ALL",
            offset: 0,
            searchTerm: searchTerm,
          },
          isInput: true,
        })
      );
    }
  };

  const handleClearInput = () => {
    dispatch(setSearchTerm(""));
  };

  const handleDeleteClose = () => {
    setDeletePopUpOpen(false);
    setAdminUserIdForDeletion("");
    // if (flag) fetchUserManagement(page, rowId);
  };

  const duplicateUserEmails = (email) => {
    // const emails = email.split("__");
    return email;

    // if (emails.length > 1) {
    //   return emails[0];
    // } else {
    // return emails;
    // }
  };

  return (
    <div>
      <Box padding={{ xs: 1, md: 2, lg: 4 }} sx={{ overflowX: "hidden" }}>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          mb={4}
        >
          <Box
            flex={{ xs: "1 1 100%", md: "1 1 40%", lg: "1 1 70%" }}
            mb={{ xs: 2, md: 0 }}
          >
            <div
              style={{
                width: "360px",
                fontFamily: "Open Sans",
                fontWeight: 700,
                lineHeight: "48px",
                fontSize: "36px",
              }}
            >
              Manage Users
            </div>
          </Box>
          <Box
            display="flex"
            justifyContent={{ xs: "flex-start", md: "flex-end" }}
            flex={{ xs: "1 1 100%", md: "1 1 60%" }}
            spacing={3}
          >
            <Box
              flex={{
                xs: "1 1 100%",
                sm: "1 1 40%",
                md: "0.2 1 20%",
                lg: "0 1 30%",
                xl: "0 0 20%",
              }}
              mb={{ xs: 2, md: 0 }}
              mr={{ xs: 1, md: 1 }}
            >
              <Button
                variant="outlined"
                fullWidth
                onClick={handleAddUser}
                sx={{
                  height: "44px",
                  borderRadius: "2rem",
                  color: "#1460AA",
                  textTransform: "none",
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  lineHeight: "20px",
                }}
              >
                Add User
              </Button>
            </Box>
            <Box
              flex={{
                xs: "1 1 100%",
                sm: "1 1 40%",
                md: "0.3 1 20%",
                lg: "0 0.3 30%",
                xl: "0 0 20%",
              }}
              mb={{ xs: 2, md: 0 }}
            >
              <Button
                fullWidth
                variant="outlined"
                sx={{
                  height: "44px",
                  borderRadius: "2rem",
                  color: "#1460AA",
                  textTransform: "none",
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  lineHeight: "20px",
                }}
              >
                Delete User
              </Button>
            </Box>
          </Box>
        </Box>

        <Box display="flex" flexDirection="column" spacing={1}>
          <Box
            display="flex"
            flexDirection={{ xs: "row", lg: "row" }}
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            <Box
              flex={{
                xs: "2 0 55%",
                md: "0 1 83%",
                lg: "1 0 10%",
                xl: "0.25 0 10%",
              }}
              mb={{ xs: 2, md: 4 }}
            >
              <TextField
                placeholder="Find Seller"
                value={searchTerm}
                variant="standard"
                size="small"
                fullWidth
                sx={{
                  fontFamily: "Open Sans",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "20px",
                  mt: "16px",
                  mb: "16px",
                  "& input": {
                    pb: "#C1C5C8",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton>
                        <Search sx={{ color: "#1460AA", ml: "-10px" }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={handleFilterChange}
                onKeyDown={handleKeyDown}
              />
            </Box>
            <Box
              flex={{ xs: "0 0 20%", md: "1 1 15%", lg: "2 1 20%" }}
              mb={{ xs: 2, md: 2 }}
            >
              <Button
                variant="contained"
                sx={{
                  height: "44px",
                  borderRadius: "1.5rem",
                  textTransform: "none",
                  px: "2rem",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "20px",
                }}
                onClick={handleFilterSubmit}
              >
                Search
              </Button>
            </Box>
            <Box
              flex={{
                xs: "1 1 100%",
                md: "1 1 25%",
                lg: "1 1 10%",
                xl: "0 0 10%",
              }}
              mb={{ xs: 2, md: 0 }}
              ml={{ lg: -50, xl: -160 }}
              mt={{ lg: 1 }}
              sx={{
                "@media (min-width:1024px) and (max-width:1150px)": {
                  marginLeft: "-250px",
                  marginRight: "20px",
                },
              }}
            >
              <FormControl variant="standard" fullWidth>
                <TextField
                  ref={textFieldRef}
                  variant="standard"
                  placeholder={"All User Roles"}
                  value={selectedOption}
                  onClick={handleClick}
                  sx={{
                    width: "100%",
                    minWidth: "150px",
                    "& input": {
                      paddingBottom: "12px",
                    },
                  }}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <ArrowDropDown
                          style={{
                            transform: anchorEl
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      width: textFieldRef.current
                        ? textFieldRef.current.clientWidth
                        : "150px",
                      margin: "0 -10px 0 0",
                      transition: "none",
                    },
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  {roles?.map((role, index) => [
                    <MenuItem
                      key={role.admin_user_role_id}
                      onClick={() =>
                        handleCheckboxChange(
                          role.admin_user_role_id,
                          role.role_en
                        )
                      }
                      sx={{ mb: "-8px", mt: "-8px" }}
                    >
                      <ListItemText primary={role.role_en} />
                      <Checkbox
                        checked={selectOptionId === role.admin_user_role_id}
                        onChange={() =>
                          handleCheckboxChange(
                            role.admin_user_role_id,
                            role.role_en
                          )
                        }
                      />
                    </MenuItem>,
                    index < roles.length - 1 && (
                      <Divider sx={{ mb: "-10px" }} />
                    ),
                  ])}
                  <Divider sx={{ mb: "-10px" }} />
                  <MenuItem
                    key="ALL"
                    onClick={() => handleCheckboxChange("ALL", "ALL User")}
                    sx={{ mb: "-8px", mt: "-8px" }}
                  >
                    <ListItemText primary="All User" />
                    <Checkbox
                      checked={selectOptionId === "ALL"}
                      onChange={() => handleCheckboxChange("ALL", "ALL User")}
                    />
                  </MenuItem>
                </Menu>
              </FormControl>
            </Box>
            <Box
              display="flex"
              flexDirection={{ md: "row" }}
              justifyContent={{ xs: "space-between", md: "flex-end" }}
              flex={{
                xs: "0 0 100%",
                md: "1 1 20%",
                lg: "1.5 0 20%",
                xl: "1 0 20%",
              }}
              mb={{ xs: 2, md: 2, lg: 2, xl: 1 }}
              mt={{ md: 2, lg: 4, xl: 4 }}
              gap={{ xs: 1 }}
            >
              <Button
                variant="text"
                size="small"
                sx={{
                  color: "#1460AA",
                  textTransform: "none",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: "15px",
                  lineHeight: "20px",
                  height: "20px",
                }}
                endIcon={<SaveAltIcon sx={{ color: "#1460AA", ml: "-6px" }} />}
                onClick={() => setImportUsersModalOpen(true)}
              >
                Import New Users
              </Button>
              <Button
                variant="text"
                sx={{
                  color: "#1460AA",
                  textTransform: "none",
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  fontSize: "15px",
                  lineHeight: "20px",
                  height: "20px",
                }}
              >
                Export to Excel
                <Box
                  position="relative"
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <ArticleRounded
                    fontSize="large"
                    sx={{
                      color: "#1460AA",
                      width: "20px",
                      height: "20px",
                      ml: "5px",
                    }}
                  />

                  <Box
                    position="absolute"
                    bottom={1.2}
                    right={-1}
                    width={5}
                    height={6}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="white"
                    borderRadius="50%"
                    p={0.25} //  padding for spacing
                  >
                    <Box
                      position="absolute"
                      bottom={0}
                      right={-1}
                      width={5}
                      height={5}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      backgroundColor="#1460AA"
                      borderRadius="50%"
                      p={0.25}
                    >
                      <ArrowUpward
                        fontSize="small"
                        style={{
                          transform: "rotate(45deg)",
                          color: "white",
                          width: "8px",
                          height: "8px",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Button>
            </Box>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "white",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)",
            zIndex: 1,
            borderRadius: "10px",
          }}
        >
          <Table sx={{ minWidth: 300 }} aria-label="manage users table">
            <TableHead sx={{ whiteSpace: "nowrap" }}>
              <TableRow height="104px">
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={isAllSelected}
                    indeterminate={isIndeterminate}
                    onChange={handleSelectAllCheckBox}
                    sx={{
                      marginLeft: {
                        lg: "20px",
                      },
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#000000",
                        fontSize: "14px",
                        lineHeight: "20px",
                      }}
                    >
                      Name
                    </div>
                    <SwapVertIcon
                      sx={{ Height: "24px", width: "24px", cursor: "pointer" }}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#000000",
                        fontSize: "14px",
                        lineHeight: "20px",
                      }}
                    >
                      User Role
                    </div>
                    <SwapVertIcon
                      sx={{ Height: "24px", width: "24px", cursor: "pointer" }}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#000000",
                        fontSize: "14px",
                        lineHeight: "20px",
                      }}
                    >
                      Joined On
                    </div>
                    <SwapVertIcon
                      sx={{ Height: "24px", width: "24px", cursor: "pointer" }}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#000000",
                        fontSize: "14px",
                        lineHeight: "20px",
                      }}
                    >
                      Last Active
                    </div>
                    <SwapVertIcon
                      sx={{ Height: "24px", width: "24px", cursor: "pointer" }}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#000000",
                        fontSize: "14px",
                        lineHeight: "20px",
                      }}
                    >
                      Status
                    </div>
                    <SwapVertIcon
                      sx={{ Height: "24px", width: "24px", cursor: "pointer" }}
                    />
                  </Box>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "background.paper",
                    zIndex: 2,
                    fontWeight: 700,
                    color: "#000000",
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                >
                  Manage
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((usr, index) => (
                // user.data?.map((usr, index) => (
                <TableRow key={index} height="104px">
                  <TableCell padding="checkbox">
                    <Checkbox
                      sx={{
                        color: "#78A1B4",
                        marginLeft: {
                          lg: "20px",
                          xl: "20px",
                        },
                      }}
                      checked={(selectRows[page] || []).includes(index)}
                      onChange={(e) => handleTableCheckBox(e, index)}
                    />
                  </TableCell>
                  <TableCell>
                    <Grid
                      container
                      alignItems="center"
                      spacing={1}
                      wrap="nowrap"
                    >
                      <Grid item>
                        <Avatar
                          sx={{
                            width: 36,
                            height: 36,
                            backgroundColor: "#E3F6FF",
                            ml: "-5px",
                            mr: "16px",
                          }}
                        >
                          <PersonRounded sx={{ color: "#91BACD" }} />
                        </Avatar>
                      </Grid>
                      <Grid sx={{ mr: "-20px" }}>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            fontFamily: "Open Sans",
                            lineHeight: "20px",
                            color: usr.active === 0 ? "#717173" : "#000000",
                          }}
                        >
                          {usr.admin_user_first_name +
                            " " +
                            usr.admin_user_last_name}
                        </div>
                        <div
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                            lineHeight: "16px",
                            fontFamily: "Open Sans",
                          }}
                        >
                          {duplicateUserEmails(usr.admin_user_email)}
                        </div>
                      </Grid>
                    </Grid>
                  </TableCell>
                  <TableCell>
                    <FormControl fullWidth>
                      <Select
                        variant="standard"
                        value={selectedRole[index] || usr.role_en}
                        // size="small"
                        displayEmpty
                        onChange={(e) => {
                          handleRole(
                            index,
                            e.target.value,
                            usr.admin_user_id,
                            usr.admin_user_role_id
                          );
                          handleToggle(index, false);
                        }}
                        disabled={usr.active === 0}
                        input={<Input disableUnderline={usr.active === 0} />}
                        renderValue={(selected) => selected}
                        IconComponent={() =>
                          open[index] ? <ExpandLess /> : <ExpandMore />
                        }
                        onOpen={() => handleToggle(index, true)}
                        onClose={() => handleToggle(index, false)}
                        sx={{ width: "180px" }}
                      >
                        {roles.map((role, roleIndex) => [
                          <MenuItem key={roleIndex} value={role.role_en}>
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              width="100%"
                              minWidth="160px"
                              sx={{ mt: "-10px", mb: "-10px" }}
                            >
                              {role.role_en}
                              <Radio
                                checked={selectedRole[index] === role.role_en}
                                value={usr.role_en || role.role_en}
                                onClick={(e) => {
                                  handleRole(index, e.target.value);
                                }}
                              />
                            </Box>
                          </MenuItem>,
                          roleIndex < roles.length - 1 && (
                            <Divider sx={{ mb: "-10px" }} />
                          ),
                        ])}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>{formattedDate(usr.joined_on_date)}</TableCell>
                  <TableCell>{formattedDate(usr.last_active_date)}</TableCell>
                  <TableCell>
                    <div
                      variant="body2"
                      style={{
                        fontFamily: "Open Sans",
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "20px",
                        color:
                          usr.active === 1 && isInactive(usr.last_active_date)
                            ? "#996600"
                            : usr.active === 1
                            ? "#439943"
                            : "#717173",
                      }}
                    >
                      {usr.active === 1 && isInactive(usr.last_active_date)
                        ? "Inactive"
                        : usr.active === 1
                        ? "Active"
                        : "Deleted"}
                    </div>
                    {usr.active === 0 ? (
                      <div
                        style={{
                          color: "#717173",
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "12px",
                          lineHeight: "16px",
                        }}
                      >
                        Deleted On {formattedDate(usr.deleted_on_date)}
                      </div>
                    ) : usr.reactivation_on ? (
                      <div
                        style={{
                          color: "#717173",
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          fontSize: "12px",
                          lineHeight: "16px",
                        }}
                      >
                        Reactivated On {formattedDate(usr.reactivation_on)}
                      </div>
                    ) : null}
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "background.paper",
                      zIndex: 1,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        position="relative"
                        display="inline-flex"
                        alignItems="center"
                      >
                        <IconButton
                          onClick={() => {
                            if (usr.active) {
                              setAdminUserIdForDeletion(usr.admin_user_id);
                              setDeletePopUpOpen(true);
                            }
                          }}
                        >
                          <Delete
                            sx={{
                              width: "24px",
                              height: "24px",
                              cursor: "pointer",
                              color: usr.active === 0 ? "#717173" : "#000000",
                            }}
                          />
                        </IconButton>

                        <Box
                          position="absolute"
                          top="50%"
                          left="43%" // Position in the center-left of the icon
                          height="15%"
                          width="1.8px"
                          bgcolor="white"
                        />

                        {/* Second Vertical Line */}
                        <Box
                          position="absolute"
                          top="50%"
                          left="54%"
                          height="15%"
                          width="1.5px"
                          bgcolor="white"
                          marginRight="5px"
                        />
                      </Box>
                      <IconButton
                        onClick={() => {
                          //  if (usr.active)
                          navigate(`/manage-user/${usr.admin_user_id}`);
                        }}
                      >
                        <Edit
                          sx={{
                            color: "#000000",
                          }}
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                // ))
              ))}
            </TableBody>
            {/* Pagination */}
            <TableFooter>
              <TableRow>
                <TableCell colSpan={7}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      mt: 2,
                      paddingLeft: {
                        lg: "20px",
                        xl: "20px",
                      },
                    }}
                  >
                    <Grid item xs={2}>
                      <FormControl variant="standard" size="small" fullWidth>
                        <InputLabel id="Items-per-page-label">
                          Item per page
                        </InputLabel>
                        <Select
                          labelId="Items-per-page-label"
                          value={rowsPerPage}
                          displayEmpty
                          renderValue={(selected) =>
                            selected === users.length ? "ALL" : selected
                          }
                          ml={2}
                          sx={{
                            width: {
                              xs: "120px",
                            },
                          }}
                        >
                          {limit.map((value, index) => [
                            <MenuItem
                              key={index}
                              value={value.page_option_value}
                              id={value.page_option_id}
                              onClick={() =>
                                handleChangeRowsPerPage(
                                  value.page_option_value,
                                  value.page_option_id
                                )
                              }
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "-8px",
                                mb: "-8px",
                                borderBottomLeftRadius: "10px",
                                borderBottomRightRadius: "10px",
                              }}
                            >
                              {value.page_option_value}
                              <Radio
                                checked={
                                  rowsPerPage === value.page_option_value
                                }
                                id={value.page_option_id}
                                value={value.page_option_value}
                                sx={{ ml: 2 }}
                              />
                            </MenuItem>,
                            index < roles.length - 1 && (
                              <Divider sx={{ mb: "-10px" }} />
                            ),
                          ])}
                          <MenuItem
                            value="ALL"
                            id="ALL"
                            onClick={() =>
                              handleChangeRowsPerPage("ALL", "ALL")
                            }
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mt: "-8px",
                              mb: "-8px",
                              borderBottomLeftRadius: "10px",
                              borderBottomRightRadius: "10px",
                            }}
                          >
                            ALL
                            <Radio
                              checked={rowsPerPage === "ALL"}
                              value="ALL"
                              sx={{ ml: 2 }}
                            />
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "background.paper",
                        zIndex: 1,
                        marginLeft: {
                          xs: "120px",
                        },
                      }}
                    >
                      <Pagination
                        count={
                          rowsPerPage === count || rowsPerPage === "ALL"
                            ? 1
                            : Math.ceil(count / rowsPerPage)
                        }
                        sx={{
                          marginLeft: {
                            lg: "20px",
                            xl: "20px",
                          },
                        }}
                        page={page + 1}
                        color="primary"
                        onChange={handleChangePage}
                      />
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Box>
      {deletePopUpOpen && adminUserIdForDeletion ? (
        <DeleteAdminUserPopUp
          open={deletePopUpOpen}
          id={adminUserIdForDeletion}
          handleClose={handleDeleteClose}
          header={"Confirm delete User ?"}
          body={
            "Are you sure you want to delete user. Deleting user will remove all their data permanently."
          }
          fetchUserManagement={fetchUserManagementData}
          page={page}
          rowId={rowId}
        ></DeleteAdminUserPopUp>
      ) : (
        <></>
      )}
      <ImportUsersModal
        open={importUsersModalOpen}
        handleClose={() => setImportUsersModalOpen(false)}
      />
    </div>
  );
};

export default ManageUsers;
